import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { OrderStatusPage, PrivacyPage, TermsPage, InvoicePage, SmsOptInPage } from './App';
import Hauler from './Hauler';
import Auth from './Auth';
import Admin from './Admin';
import Client from './Client';
import HaulerSetup, { ResetPasswordPage } from './HaulerSetup';
import './Auth.css';

const path = window.location.pathname;
const root = ReactDOM.createRoot(document.getElementById('root'));

if (path === '/admin') {
  root.render(<Admin />);
} else if (path === '/hauler') {
  root.render(<Hauler />);
} else if (path === '/hauler-login') {
  const wantsSignup = new URLSearchParams(window.location.search).get('signup') === '1';
  root.render(
    <Auth
      role="hauler"
      defaultPage={wantsSignup ? 'signup' : undefined}
      onLogin={function() { window.location.href = '/hauler'; }}
    />
  );
} else if (path === '/hauler-signup') {
  root.render(
    <Auth
      role="hauler"
      defaultPage="signup"
      onLogin={function() { window.location.href = '/hauler'; }}
    />
  );
} else if (path === '/hauler-setup') {
  root.render(<HaulerSetup />);
} else if (path === '/reset-password') {
  root.render(<ResetPasswordPage />);
} else if (path === '/login') {
  const loginNext = new URLSearchParams(window.location.search).get('next');
  root.render(
    <Auth
      role="client"
      onLogin={function(user, role) {
        if (loginNext && loginNext.startsWith('/order/')) {
          window.location.href = loginNext;
        } else {
          window.location.href = role === 'hauler' ? '/hauler' : '/client';
        }
      }}
    />
  );
} else if (path === '/signup') {
  root.render(
    <Auth
      role="client"
      defaultPage="signup"
      onLogin={function(user, role) {
        window.location.href = role === 'hauler' ? '/hauler' : '/client';
      }}
    />
  );
} else if (path.startsWith('/order/')) {
  const orderId = path.slice('/order/'.length);
  root.render(<OrderStatusPage orderId={orderId} />);
} else if (path.startsWith('/invoice/')) {
  const invoiceId = path.slice('/invoice/'.length);
  root.render(<InvoicePage invoiceId={invoiceId} />);
} else if (path === '/client' || path === '/account') {
  root.render(<Client />);
} else if (path === '/privacy') {
  root.render(<PrivacyPage />);
} else if (path === '/terms') {
  root.render(<TermsPage />);
} else if (path === '/sms-opt-in') {
  root.render(<SmsOptInPage />);
} else {
  root.render(<App />);
}